import { Model } from "./model";

export class Rank extends Model {
    id: number;
    name: string;
    from: number;
    to: number;
    color: string;
    translation?: string;
    percent?: number;
}


// WEBPACK FOOTER //
// ./src/models/rank.model.ts